import React from "react";

export function ObservedBadge({ observed }) {
  return observed ? (
    <span className="tag-observed" data-testid="badge-observed">OBSERVED</span>
  ) : (
    <span className="tag-inferred" data-testid="badge-inferred">INFERRED</span>
  );
}

export function ConfidenceBadge({ level }) {
  const cls = `tag-inferred tag-confidence-${level || "medium"}`;
  return (
    <span className={cls} style={{ background: "#fff" }} data-testid={`badge-confidence-${level}`}>
      conf · {level || "medium"}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const map = {
    high: { bg: "#FEF2F2", text: "#DC2626", border: "#FCA5A5", label: "P1 HIGH" },
    medium: { bg: "#FFFBEB", text: "#D97706", border: "#FCD34D", label: "P2 MED" },
    low: { bg: "#ECFDF5", text: "#059669", border: "#6EE7B7", label: "P3 LOW" },
  };
  const s = map[priority] || map.medium;
  return (
    <span
      data-testid={`badge-priority-${priority}`}
      className="inline-flex items-center px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider border"
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      {s.label}
    </span>
  );
}
